import React, { useState } from "react";
import "./styles/PyramidApp.css";
import Board from "./Components/Board";
import TopBar from "./Components/TopBar";
import Helppanel from "./Components/Helppanel";
import { CharacterCount, GameStyle } from "./Setting_difficulty";
import FullscreenToggle from "./FullscreenToggle";

interface PyramidProps {
  gameStyle?: GameStyle;
  characterCount?: CharacterCount;
}

const PyramidApp = (props: PyramidProps) => {
  type GameModeType = "Control" | "Edit" | "Debug" | "Run";
  type MoveButtonType = "AB" | "AC" | "BC" | "BA" | "CA" | "CB" | "next" | null;
  const [isOpenPanel, setisOpenPanel] = useState<boolean>(false);
  const [MoveButton, setMoveButton] = useState<MoveButtonType>(null);
  const [GameMode, setGameMode] = useState<GameModeType>("Edit");
  const [Message, setMessage] = useState<string>("Начни игру!");
  return (
    <div id="pyramid-content">
      <div className="pyramid-conteiner">
        <div className="pyramid-Logo-name">
          <a className="pyramid-logo" href="https://kotobot.app/index.html">
            <img className="pyramid-logo" src="/img/kotobot.svg" alt="Kotobot logo" />
          </a>
          <div className="pyramid-mainsubtitle">Пирамида</div>
          <FullscreenToggle/>
        </div>
        <TopBar
          GameMode={GameMode}
          setGameMode={setGameMode}
          setMoveButton={setMoveButton}
          Message={Message}
          setisOpenPanel={setisOpenPanel}
        />
        <Board
          GameMode={GameMode}
          MoveButton={MoveButton}
          setMoveButton={setMoveButton}
          setMessage={setMessage}
          Message={Message}
          characterCount={props.characterCount}
          gameStyle={props.gameStyle}
        />
        <Helppanel isOpenPanel={isOpenPanel} setisOpenPanel={setisOpenPanel} />
      </div>
    </div>
  );
};

export default PyramidApp;
